import {callsApi} from 'sources/api';
import urlWithParams from 'utils/urlWithParams';
import CrmActivity from 'records/CrmActivity';
import cancelIfSending from 'sources/cancelIfSending';

const CrmInternalActivitySource = cancelIfSending({
  fetchActivity(fileUploadId) {
    const url = urlWithParams(`/crm_activities`, {
      file_upload_id: fileUploadId,
    });
    return callsApi.getJson(url).then(activity => ({
      data: new CrmActivity({
        ...activity,
        activityType: activity.type,
        crmAccount: activity.account,
        crmContact: activity.contact,
        crmOpportunity: activity.opportunity,
      }),
    }));
  },
});

export default CrmInternalActivitySource;
